/* sucrase/dist/esm/util/getNonTypeIdentifiers.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.getNonTypeIdentifiers = getNonTypeIdentifiers;
    const tslib_1 = require("tslib");
    const tokenizer_1 = require("bfb18d0576") /* ../parser/tokenizer */;
    const types_1 = require("f0c35cbd76") /* ../parser/tokenizer/types */;
    const JSXTransformer_1 = require("a0e577c292") /* ../transformers/JSXTransformer */;
    const getJSXPragmaInfo_1 = tslib_1.__importDefault(require("d797c101ed") /* ./getJSXPragmaInfo */);
    function getNonTypeIdentifiers(tokens, options) {
        const jsxPragmaInfo = (0, getJSXPragmaInfo_1.default)(options);
        const nonTypeIdentifiers = new Set();
        for (let i = 0; i < tokens.tokens.length; i++) {
            const token = tokens.tokens[i];
            if (token.type === types_1.TokenType.name &&
                !token.isType &&
                (token.identifierRole === tokenizer_1.IdentifierRole.Access ||
                    token.identifierRole === tokenizer_1.IdentifierRole.ObjectShorthand ||
                    token.identifierRole === tokenizer_1.IdentifierRole.ExportAccess) &&
                !token.shadowsGlobal) {
                nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
            }
            if (token.type === types_1.TokenType.jsxTagStart) {
                nonTypeIdentifiers.add(jsxPragmaInfo.base);
            }
            if (token.type === types_1.TokenType.jsxTagStart &&
                i + 1 < tokens.tokens.length &&
                tokens.tokens[i + 1].type === types_1.TokenType.jsxTagEnd) {
                nonTypeIdentifiers.add(jsxPragmaInfo.base);
                nonTypeIdentifiers.add(jsxPragmaInfo.fragmentBase);
            }
            if (token.type === types_1.TokenType.jsxName && token.identifierRole === tokenizer_1.IdentifierRole.Access) {
                const identifierName = tokens.identifierNameForToken(token);
                // Lower-case single-component tag names like "div" don't count.
                if (!(0, JSXTransformer_1.startsWithLowerCase)(identifierName) || tokens.tokens[i + 1].type === types_1.TokenType.dot) {
                    nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
                }
            }
        }
        return nonTypeIdentifiers;
    }
}
